import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { LeadsPage, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";
import { Message } from "messages";

const useLeadsAdapter = (
  page: LeadsPage,
  messageHandler: (
    ref: React.MutableRefObject<HTMLIFrameElement | null>
  ) => (message: Message | undefined) => Message | undefined
): ComponentProps<typeof IFrame> => {
  let [searchParams] = useSearchParams();
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig("leads", page);
  const basePath = config.iFrameUrl;
  const match = useMatch(`/${config.containerPath}/*`);
  const src = `${basePath}/${match?.params["*"] ?? ""}?${searchParams}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Leads", config.containerPath, messageHandler(ref));
  return {
    ref,
    basePath: basePath,
    src: staticSrc,
    title: config.title,
  };
};

export { useLeadsAdapter };
